export default __webpack_public_path__ + "static/media/utility5.b202b5bd.svg";